"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _Debug = /*#__PURE__*/ _interop_require_default(require("../../util/Debug"));
const _emit = /*#__PURE__*/ _interop_require_default(require("../../util/emit"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let BaseRender = class BaseRender {
    emit(data) {
        this.log.api(data);
        this.evt.evt.emit('UI', {
            status: 0,
            data: `File : ${data}`
        });
    }
    emitW(data) {
        this.log.warn(data);
        this.evt.evt.emit('UI', {
            status: 1,
            data: `File : ${data}`
        });
    }
    emitE(data) {
        this.log.error(data);
        this.evt.evt.emit('UI', {
            status: -1,
            data: `File : ${data}`
        });
    }
    /**
   * Function that prepares data to be used in template
   * This should be strictly overridden by deriving class
   *
   * @returns {Promise<void>}
   */ async prepare() {
        console.log('BaseRender::prepare -> Should be overriden');
    }
    /**
   * Class responsible for rendering code
   *
   * @param {string} - dir - dir where file will be rendered
   * @param {string} - filename - filename of file to be rendered
   * @param {Object} - ctx - context to render this file
   */ constructor({ dir = '', filename = '', ctx }){
        this.dir = dir;
        this.filename = filename;
        this.ctx = ctx;
        this.evt = new _emit.default();
        this.log = new _Debug.default('BaseRender');
    }
};
const _default = BaseRender;
